import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

//SERVICE
import { LandingCultureMxService } from "./landingculturemx.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import * as $ from 'jquery';

@Component({
  selector: 'app-landingculturemx',
  templateUrl: './landingculturemx.component.html',
  styleUrls: ['./landingculturemx.component.scss'],
  animations : fuseAnimations
})
export class LandingculturemxComponent implements OnInit {
  origen: any;
  producto: any;
  private _unsubscribeAll: Subject<any>;
  productosContratadosCA: any;
  productosAsignados: any[] = [];
  cargando:boolean=true;
  titleProducto:any;
  userData:any;
  instituto:any;
  itbmUser:boolean=false;
  videoInfoCarca=false;

  listaProductosCA = [
    {clave: 'culture5.0', nombre: 'Culture Audit 5.0'},
    {clave: 'cultureCR', nombre: 'Culture Audit Costa Rica'},
    {clave: 'cultureGoFlow', nombre: 'Culture Audit GoFlow'},
    {clave: 'culturePanama', nombre: 'Culture Audit 5.0 Panamá'},
    {clave: 'cultureSP', nombre: 'Culture Audit 5.0 Strategic Partners'},
    {clave: 'cultureMX_2021', nombre: 'Culture Audit 2021 México'},
    {clave: 'cultureCR_2021', nombre: 'Culture Audit 2021 Costa Rica'},
    {clave: 'culturePA_2021', nombre: 'Culture Audit 2021 Panamá'},
    {clave: 'GoFlow_1_2021', nombre: 'SP 2021'},
    {clave: 'GoFlow_2_2021', nombre: 'Culture Audit GoFlow 2 2021'},
    {clave: 'culture_ICCA', nombre: 'Internal Communication Culture Audit (ICCA)'},
    {clave: 'culture_ICCAMEX', nombre: 'Internal Communication Culture Audit (ICCA)'},
    {clave: 'Culture_Brief', nombre: 'Culture Brief'},
    {clave: 'Culture_AuditCAYC', nombre: 'Culture Audit'},
    {clave: 'Culture_Brief_Culture_Audit', nombre: 'Culture Brief + Culture Audit'},
    {clave: 'SP_2022', nombre: 'SP 2022'},
    {clave: 'GoFlow_2_2022', nombre: 'Culture Audit GoFlow 2 2022'},
    {clave: 'Culture_Estandar_1', nombre: 'Culture Audit Estandar 1'},
    {clave: 'Culture_CA&C', nombre: 'Culture Audit® CA&C'},
    {clave: 'Culture_Brief_(certificar)_2022', nombre: 'Culture Brief (certificar) 2022'},
    {clave: 'Culture_Audit_(certificar,rkg.)', nombre: 'Culture Audit (certificar,rkg.)'},
    {clave: 'Culture_Audit_(certificar,rkg.yadic.)', nombre: 'Culture Audit (certificar,rkg. y adic.)'},
    {clave: 'Culture_Audit_(certificar,rkg.yadic.)_2024', nombre: 'Culture Audit (certificar, rkg y adic) 2024'},
    {clave: 'Culture_Brief_(certificar)_2024', nombre: 'Culture Brief (certificar) 2024'},
    {clave: 'Culture_Audit_(certificar_y_ranking)_2024', nombre: 'Culture Audit (certificar y ranking) 2024'},
  ];
  // videoCAyC = "https://drive.google.com/file/d/1S73W5-4umy7lIa0ZiwOKzVIYny5nQLZ0/view";

  videoCAyC:any;
  videoCAyCPoster: any;
  constructor(
    private activatedRoute:ActivatedRoute,
    private http:HttpClient,
    private landingService : LandingCultureMxService,
    private router: Router,
    private wizardService: WizardService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    this._unsubscribeAll = new Subject();
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    if(localStorage.getItem('userBypass')){
      this.userData=JSON.parse(localStorage.getItem('userBypass'));
        console.log(this.userData);
        console.log(this.userData.level);
      if(this.userData.level==2){
        this.itbmUser=true;
      }
    }

    this.translateSrv.onLangChange.subscribe(() => {
      this.cambioVideo(this.translateSrv.currentLang);
    });
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(params => {
      console.log(params);
        this.origen = params;
        if (this.origen.producto=="Culture_Brief" || this.origen.producto=="Culture_AuditCAYC" || this.origen.producto=="Culture_Brief_Culture_Audit") {
          this.videoInfoCarca=true;
        }

    });
    this.productosCulture();
    this.obtieneInstituto();

  }

  cambioVideo(lang){

    if (lang=="es") {
      $("#videoLanding").attr("src",DATOS_API.urlAssets + 'video/landing/CAYC/certificacion.mp4');
      $("#videoLanding").attr("poster",DATOS_API.urlAssets + 'video/landing/CAYC/poster.jpg');
    }else{
      $("#videoLanding").attr("src",DATOS_API.urlAssets + 'video/landing/CAYC/certify_sub.mp4');
      $("#videoLanding").attr("poster",DATOS_API.urlAssets + 'video/landing/CAYC/poster.jpg');
    }
  }

  productosCulture(){
    this.productosAsignados=[];
    this.landingService.getProductosEmpresa().subscribe((respuesta:backInter.infoProductos) => {

      this.titleProducto = this.listaProductosCA[this.listaProductosCA.findIndex(item => item.clave == this.origen.producto)].nombre;
      this.productosContratadosCA = respuesta.productosCultureAuditV2;
      this.productosContratadosCA.forEach(producto => {
        switch (this.origen.producto) {
          case "culture5.0":
            if(!producto.tipo){
              this.productosAsignados.push(producto);
            }
          break;
          case "cultureCR":
            if(producto.tipo == 4){
              this.productosAsignados.push(producto);
            }
          break;
          case "cultureGoFlow":
            if(producto.tipo == 5){
              this.productosAsignados.push(producto);
            }
          break;
          case "culturePanama":
            if(producto.tipo == 6){
              this.productosAsignados.push(producto);
            }
          break;
          case "cultureSP":
            if(producto.tipo == 7){
              this.productosAsignados.push(producto);
            }
          break;
          case "cultureMX_2021":
            if(producto.tipo == 10){
              this.productosAsignados.push(producto);
            }
          break;
          case "cultureCR_2021":
            if(producto.tipo == 11){
              this.productosAsignados.push(producto);
            }
          break;
          case "culturePA_2021":
            if(producto.tipo == 12){
              this.productosAsignados.push(producto);
            }
          break;
          case "GoFlow_1_2021":
            if(producto.tipo == 14){
              this.productosAsignados.push(producto);
            }
          break;
          case "GoFlow_2_2021":
            if(producto.tipo == 15){
              this.productosAsignados.push(producto);
            }
          break;
          case "culture_ICCA":
            if(producto.tipo == 18){
              this.productosAsignados.push(producto);
            }
          break;
          case "culture_ICCAMEX":
            if(producto.tipo == 19){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_Brief":
            if(producto.tipo == 20){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_AuditCAYC":
            if(producto.tipo == 34){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_Brief_Culture_Audit":
            if(producto.tipo == 21){
              this.productosAsignados.push(producto);
            }
          break;
          case "SP_2022":
            if(producto.tipo == 22){
              this.productosAsignados.push(producto);
            }
          break;
          case "GoFlow_2_2022":
            if(producto.tipo == 23){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_Estandar_1":
            if(producto.tipo == 24){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_CA&C":
            if(producto.tipo == 25){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_Brief_(certificar)_2022":
            if(producto.tipo == 26){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_Audit_(certificar,rkg.)":
            if(producto.tipo == 27){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_Audit_(certificar,rkg.yadic.)":
            if(producto.tipo == 28){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_Audit_(certificar,rkg.yadic.)_2024":
            if(producto.tipo == 30){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_Brief_(certificar)_2024":
            if(producto.tipo == 31){
              this.productosAsignados.push(producto);
            }
          break;
          case "Culture_Audit_(certificar_y_ranking)_2024":
            if(producto.tipo == 32){
              this.productosAsignados.push(producto);
            }
          break;
        }
      });
      console.log("productosAsignados:",this.productosAsignados);
      this.cargando=false;
    }, error => {
      console.log("error", error);
    })
  }
  navigateTo(idCulture){
    let rutaCA: string;
    switch (this.origen.producto) {
      // case "culture5.0": break;
      // case "cultureCR": break;
      // case "cultureGoFlow": break;
      // case "culturePanama": break;
      // case "cultureSP": break;
      case "cultureMX_2021": rutaCA = '/culture_MX6/cultureAudit'; break;
      case "cultureCR_2021": rutaCA = '/culture_MX7/cultureAudit'; break;
      case "culturePA_2021": rutaCA = '/culture_MX8/cultureAudit'; break;
      case "GoFlow_1_2021": rutaCA = '/culture_MX9/cultureAudit'; break;
      case "GoFlow_2_2021": rutaCA = '/culture_MX10/cultureAudit'; break;
      case "SP_2022": rutaCA = '/culture_MX11/cultureAudit'; break;
      case "GoFlow_2_2022": rutaCA = '/culture_MX12/cultureAudit'; break;
      case "Culture_Estandar_1": rutaCA = '/culture_MX13/cultureAudit'; break;
      case "Culture_CA&C": rutaCA = '/culture_MX14/cultureAudit'; break;
      case "Culture_Brief_(certificar)_2022": rutaCA = '/culture_MX15/cultureAudit'; break;
      case "Culture_Audit_(certificar,rkg.)": rutaCA = '/culture_MX16/cultureAudit'; break;
      case "Culture_Audit_(certificar,rkg.yadic.)": rutaCA = '/culture_MX17/cultureAudit'; break;
      case "Culture_Audit_(certificar,rkg.yadic.)_2024": rutaCA = '/culture_MX18/cultureAudit'; break;
      case "Culture_Audit_(certificar,rkg.yadic.)_2024": rutaCA = '/culture_MX18/cultureAudit'; break;
      case "Culture_Brief_(certificar)_2024": rutaCA = '/culture_MX19/cultureAudit'; break;
      case "Culture_Audit_(certificar_y_ranking)_2024": rutaCA = '/culture_MX20/cultureAudit'; break;
      case "culture_ICCA": rutaCA = '/icca/cultureAudit'; break;
      case "culture_ICCAMEX": rutaCA = '/icca/cultureAudit'; break;
      case "Culture_Brief": rutaCA = '/Culture_Brief/cultureAudit'; break;
      case "Culture_AuditCAYC": rutaCA = '/Culture_Audit/cultureAudit'; break;
      case "Culture_Brief_Culture_Audit": rutaCA = '/Culture_Brief_Culture_Audit/cultureAudit'; break;
      default: rutaCA = '/cultureAudit';
    }
    this.router.navigate([rutaCA, idCulture]);
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; break;
      case '3': case 'HK': this.instituto = 'HK'; break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK'; break;
      case '6': case 'FL': this.instituto = 'FL'; break;
      case '8': case 'IZZI': this.instituto = 'IZZI'; break;
      case '11': case 'BR': this.instituto = 'BR'; break;
      case '14': case 'GCTI': this.instituto = 'GCTI'; break;
      case '15': case 'ES': this.instituto = 'ES'; break;
      case '18': case 'AMCO': this.instituto = 'AMCO'; break;
      case '19': case 'AMCO': this.instituto = 'MX'; break;
    }
    setTimeout(() => {
      this.cambioVideo(this.translateSrv.currentLang);

    }, 2000);
  }
}
